import { useState, useEffect } from 'react';
import {
  
  Activity} from 'lucide-react';
import { message } from 'antd';
import axios from "../../../utils/axios";
import { useLocation } from "react-router-dom";
import EducationDashboard from '../education/educationDashboard';
import QSRDashboard from '../QsrFastFood/qsrfastDashboard';

const ModernCafeDashboard = () => {
  const cafeId = localStorage.getItem('cafeId');
  const user = JSON.parse(localStorage.getItem('user'));
  const organizationId = localStorage.getItem('organizationId');
  const [dashboardConfig, setDashboardConfig] = useState(null);
  const [currentTime] = useState(new Date());
  const [loading, setLoading] = useState(false);

  const [peopleCount, setPeopleCount] = useState(0);
  const [mobileUsage] = useState(68);
  const [alerts, setAlerts] = useState([]);
  const [alertsCount, setAlertsCount] = useState(0);
  const [peopleCountData, setPeopleCountData] = useState([]);
  const [cameraCount, setCameraCount] = useState(0);
  const [tableOcc, setTableOcc] = useState([]);
  const [sector, setSector] = useState(null)

  const location = useLocation();
  const projectname = location.state?.projectname || localStorage.getItem('selectedProject');

  /* ---------------- DASHBOARD CONFIG ---------------- */
  const fetchDashboardConfig = async () => {
    try {
      const res = await axios.post('/fetch-dashboard-settings', {
        organizationId,
        username: user?.username,
        projectname
      });

      if (res.data?.success) {
        setDashboardConfig(res.data.data.pages?.dashboard);
      }
    } catch (err) {
      console.error("Dashboard config fetch failed", err);
    }
  };

  const getProjectDetails = async () => {
    try {
      const res = await axios.post("/get-project-details", { projectName: projectname, organizationId });

      if (res?.data?.project?.mainCategory) {
        setSector(res.data.project.mainCategory);
      }
    } catch(err) {
      if (err.response && err.response.data) {
        message.warning(
          err.response?.data?.message ||
          err.response?.data?.msg ||
          "Something went wrong"
        );

      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
        } else if (err.response && err.response.status === 401) {
        message.error('User not authorised');
      } else {
        message.error('Something went wrong');
      }
    }
  };

  useEffect(()=> {
    getProjectDetails()
  },[projectname])

  /* ---------------- DATA FETCH ---------------- */
  const fetchAlerts = async () => {
    try {
      setLoading(true);
      const res = await axios.post("/get-recent-alerts", { cafeId });

      if (res?.data?.alerts) {
        setAlerts(res.data.alerts.map((a, i) => ({
          key: i,
          type: a.alertType,
          camera: a.cameraId,
          time: new Date(a.createdOn).toLocaleString(),
          severity: (a.severity || '').toLowerCase()
        })));
      }

      if (res?.data?.total) setAlertsCount(res.data.total);
    } catch {
      message.error("Error fetching alerts");
    } finally {
      setLoading(false);
    }
  };

  const getPersonCount = async () => {
    const res = await axios.post("/get-person-count", { cafeId });
    if (res?.data?.personCount) setPeopleCount(res.data.personCount);
  };

  const getCustomerCountGraphData = async () => {
    const res = await axios.post("/get-customer-count-graph-data", { cafeId });
    if (res?.data?.data) setPeopleCountData(res.data.data);
  };

  const getCameraCount = async () => {
    const res = await axios.post("/get-camera-count", { cafeId });
    if (res?.data?.cameraCount) setCameraCount(res.data.cameraCount);
  };

  const getTableOccupancyData = async () => {
    const res = await axios.post("/get-table-occupancy-data", { cafeId });
    if (res?.data?.tables) setTableOcc(res.data.tables);
  };

  useEffect(() => {
    fetchDashboardConfig();
    fetchAlerts();
    getPersonCount();
    getCustomerCountGraphData();
    getCameraCount();
    getTableOccupancyData();
  }, []);






  const DashboardRouter = ({ sector, dashboardConfig }) => {
    switch (sector) {

      case "Education":
        return <EducationDashboard config={dashboardConfig} />;

      case "QSR / Fast Food":
        return <QSRDashboard config={dashboardConfig} />;

      default:
        return <div>No dashboard available</div>;
    }
  };

  /* ---------------- UI (UNCHANGED) ---------------- */
  return (
    <div className="min-h-screen max-w-7xl mx-auto">

      {/* HEADER */}
      <div className="mb-8">
        <h1 className="text-4xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
          Vision AI Analytics
        </h1>
        <p className="text-gray-600 flex items-center gap-2">
          <Activity className="w-4 h-4" /> {currentTime.toLocaleString()}
        </p>
      </div>

      {sector && <DashboardRouter
        sector={sector}
        dashboardConfig={dashboardConfig}
      />}

    </div>
  );
};

export default ModernCafeDashboard;